import { branch, compose, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core';

import withPopover from 'shared/hocs/withPopover';
import { getName } from 'modules/appointmentInfo/utils/participantInfo';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { CLOSED_APPOINTMENT_STATUSES } from 'modules/common/constants/appointmentStatuses';
import { changePatientInfoTab } from 'modules/appointmentInfo/actions/changePatientInfoTab';
import { updateAppointmentGroupCurrentAppointment } from 'modules/appointmentInfo/actions/updateAppointmentGroupCurrentAppointment';

import GroupNavigation from './GroupNavigation';


const mapStateToProps = (state) => {
  const { currentAppointment } = state.appointmentInfo;
  const { group, status, requestStatus, fetchGroupedStatus } = state.appointmentInfo.currentAppointment;
  const currentAppointmentId = state.appointmentInfo.currentAppointment.appointmentId;
  const isGroupedAppointment = !!state.appointmentInfo.currentAppointment.group;
  if (!isGroupedAppointment) return {};

  const archiveOpened = state.queues.common.appointmentInfo.isArchiveOpened;
  const isClosed = CLOSED_APPOINTMENT_STATUSES.includes(status);

  const tempApptGroup = group.appointments.filter(
    tempAppt => isClosed
      ? CLOSED_APPOINTMENT_STATUSES.includes(tempAppt.status)
      : !CLOSED_APPOINTMENT_STATUSES.includes(tempAppt.status),
  );

  const currSubjectName = getName(currentAppointment.subjects[0].user.profile, { withMiddleName: true });
  const currIndex = tempApptGroup.findIndex(({ appointmentId }) => currentAppointmentId === appointmentId);
  const { forceCloseAppointmentEnabled } = currentAppointment.service.config;

  return {
    group,
    isClosed,
    currIndex,
    archiveOpened,
    currSubjectName,
    isGroupedAppointment,
    forceCloseAppointmentEnabled,
    appointmentGroup: tempApptGroup,
    isShowNavigation: requestStatus === requestsStatuses.success && fetchGroupedStatus !== requestsStatuses.pending,
  };
};

export default compose(
  connect(mapStateToProps, { setSelectedAppointmentId: updateAppointmentGroupCurrentAppointment, changePatientInfoTab }),
  withPopover(),
  withStyles(({ topArrow }) => ({ topArrow })),
  injectIntl,
  branch(
    ({ isGroupedAppointment, isShowNavigation }) => !isGroupedAppointment || !isShowNavigation,
    renderNothing,
  ),
)(GroupNavigation);
